<template>
  <div class="introduce">
    <slot name="introduce"></slot>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.introduce {
  padding-bottom: 64px;
  margin-bottom: 32px;
  text-indent: 2em;
  font-size: 16px;
  line-height: 1.5;
  font-weight: 600;
  color: #606266;
  border-bottom: 1px dashed #2c75f8;
}
</style>